import { render } from "./SoftButton.vue?vue&type=template&id=53a3684a"
import script from "./SoftButton.vue?vue&type=script&lang=js"
export * from "./SoftButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Data\\Disk D\\M\\doo-q.com\\vue-soft-ui-dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__